import clear from './clear';
import inputs from './inputs';
import nearest from './nearest';
import project from './project';
import scales from './scales';
import toggle from './toggle';
import translate from './translate';
import zoom from './zoom';
var compilers = [project, toggle, scales, translate, zoom, inputs, nearest, clear];
export function forEachTransform(selCmpt, cb) {
  for (var _i = 0; _i < compilers.length; _i++) {
    var t = compilers[_i];

    if (t.has(selCmpt)) {
      cb(t);
    }
  }
}